/**
 * Format a date string or Date object to a localized string
 * @param date - Date string or Date object to format
 * @returns Formatted date string
 */
export const formatDate = (date: string | Date): string => {
  if (!date) return '';
  
  let dateObj: Date;
  if (typeof date === 'string') {
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [y, m, d] = date.split('-').map(Number);
      dateObj = new Date(y, m - 1, d);
    } else {
      dateObj = new Date(date);
    }
  } else {
    dateObj = date;
  }
  
  if (isNaN(dateObj.getTime())) return '';
  
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }).format(dateObj);
};

/**
 * Format amount as whole-number Afghani display (no decimals, no USD symbol)
 * @param amount - Number to format as currency
 * @param _currency - Kept for backward compatibility, ignored in formatting
 * @returns Formatted currency string
 */
export const formatCurrency = (amount: number | string, _currency: string = 'AFN'): string => {
  if (amount === null || amount === undefined || amount === '') return '';
  
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
  // Handle NaN case
  if (isNaN(numAmount)) return '';
  
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(numAmount);
};

/**
 * Format a number with thousand separators
 * @param number - Number to format
 * @returns Formatted number string
 */
export const formatNumber = (number: number | string): string => {
  if (number === null || number === undefined || number === '') return '';
  
  const numValue = typeof number === 'string' ? parseFloat(number) : number;
  
  // Handle NaN case
  if (isNaN(numValue)) return '';
  
  return new Intl.NumberFormat('en-US').format(numValue);
}; 

export const formatAfCurrency = (amount: number | string, suffix: string = '؋'): string => {
  if (amount === null || amount === undefined || amount === '') return '';

  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(numAmount)) return '';

  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(numAmount);

  // ؋ prefix matches Persian/Dari convention used elsewhere in the app (e.g. ServiceSelector)
  if (suffix === '؋') {
    return `؋${formatted}`;
  }

  return `${formatted} ${suffix}`;
};